import { useAppScrollRef } from '@doltech/core/lib/appScroll/withAppScroll';
import { BlogSticky } from '@doltech/ui/lib/figma/Blog/BlogSticky';
import { BlogPromotion } from '@doltech/ui/lib/figma/BlogPromotion/BlogPromotion';
import * as React from 'react';
import styled from 'styled-components';

const Main = styled(BlogSticky)`
  width: 280px;
`;

export const DailyLearningLeftSideBar = () => {
  const { appScrollRef } = useAppScrollRef();
  return (
    <Main
      stickyId="left-interaction-sidebar-promotion"
      scrollContainerElm={appScrollRef.current}
      stickOnElm=".left-sidebar-stick"
      hideWhenIntersectWithElms={[
        '#footer-author',
        '#content-footer',
        '#compact-footer',
        '.common-footer',
        '#extra-sections',
        '.footer-with-register',
      ]}
      offsetY={144}
      stickOnElmPosition={{
        align: 'right',
        gapInPx: 64,
      }}
      stickyMode="ALWAYS_SHOW"
    >
      <BlogPromotion />
    </Main>
  );
};
